// extracted by mini-css-extract-plugin
module.exports = {"spacer":"isKPPvhlhMJ9enCwT7_Fz","headerText":"_3ygB2WO7tlKf42qb0NrjA3","sortIcon":"_1oGgpE4PWdo7s3TzYBzNk","menuPopup":"_3BPV-YMWdu4B9KRLVlvjOS"};